import useWebChatUIContext from '/druid/useWebChatUIContext';

export default function useNonce() {
  const { nonce } = useWebChatUIContext();

  return [nonce];
}
